import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ShareVars } from "@app/shared/services/share.vars";

@Component({
    selector: "app-terms-and-conditions",
    templateUrl: "./terms_and_conditions.component.html",
    styleUrls: ["./terms_and_conditions.component.scss"],
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
    constructor(private route: ActivatedRoute) {
        ShareVars.isBusy = false;
    }
    ngAfterViewInit() {
        this.route.fragment.subscribe((fragment) => {
            if (!fragment) return;

            setTimeout(() => {
                const el = document.getElementById(fragment);

                if (el) {
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            }, 100);
        });
    }

    ngOnInit() {}

    ngOnDestroy() {}
}
